const millions = {};

function currencyFormatDE(num, dec) {
  return num
    .toFixed(dec) // always two decimal digits
    .replace(".", ",") // replace decimal point character with ,
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
}

millions.install = function(Vue) {
  Vue.filter("number", (v, d) => {
    if (d === 0) {
      v = parseInt(v);
    } else {
      v = parseFloat(v);
    }
    if (isNaN(v)) {
      v = 0;
    }
    return currencyFormatDE(v, d);
  });
  Vue.filter("number1", (v, d) => {
    if (d === 0) {
      v = parseInt(v);
    } else {
      v = parseFloat(v);
    }
    if (isNaN(v)) {
      v = 0;
    }
    v = v.toFixed(d);
    const formatter = new Intl.NumberFormat("es-AR", {
      minimumFractionDigits: d
    });
    return formatter.format(v);
  });
  Vue.filter("textnumber", (v, d) => {
    const formatter = new Intl.NumberFormat("es-AR", {
      minimumFractionDigits: d
    });
    const init = v;
    if (d === 0) {
      v = parseInt(v);
    } else {
      v = parseFloat(v);
    }
    if (isNaN(v)) {
      return init;
    } else {
      return formatter.format(v);
    }
  });
  Vue.filter("dsub3", v => {
    return v.substr(0, 3);
  });
  Vue.filter("date", v => {
    if (v) {
      const months = {
        "0": "01",
        "1": "02",
        "2": "03",
        "3": "04",
        "4": "05",
        "5": "06",
        "6": "07",
        "7": "08",
        "8": "09",
        "9": "10",
        "10": "11",
        "11": "12"
      };

      let dt = new Date(v);
      const year = dt.getFullYear();
      const month = dt.getMonth();
      let day = dt.getDate().toString();
      if (day.length === 1) {
        day = `0${day}`;
      }
      return `${day}-${months[month]}-${year}`;
    } else {
      return "";
    }
  });
  Vue.filter("dia", v => {
    if (v) {
      let dt = new Date(v);
      let day = dt.getDate().toString();
      if (day.length === 1) {
        day = `0${day}`;
      }
      return `${day}`;
    } else {
      return "";
    }
  });
  Vue.filter("dateletra", v => {
    const months = {
      "0": "Ene",
      "1": "Feb",
      "2": "Mzo",
      "3": "Abr",
      "4": "Myo",
      "5": "Jun",
      "6": "Jul",
      "7": "Ago",
      "8": "Sep",
      "9": "Oct",
      "10": "Nov",
      "11": "Dic"
    };

    if (v === 0) {
      return "";
    } else {
      let dt = new Date(v);
      const year = dt.getFullYear();
      const month = dt.getMonth();
      let day = dt.getDate().toString();
      if (day.length === 1) {
        day = `0${day}`;
      }
      return `${isNaN(day) ? "" : day} ${months[month] ? months[month] : ""} ${
        year ? "de" : ""
      } ${isNaN(year) ? "" : year}`;
    }
  });
  Vue.filter("periodo", v => {
    if (v) {
      var year = v.substr(0, 4);
      var dmes = parseInt(v.substr(4, 2));
      var mes = [];
      mes[1] = "Enero";
      mes[2] = "Febrero";
      mes[3] = "Marzo";
      mes[4] = "Abril";
      mes[5] = "Mayo";
      mes[6] = "Junio";
      mes[7] = "Julio";
      mes[8] = "Agosto";
      mes[9] = "Septiembre";
      mes[10] = "Octubre";
      mes[11] = "Noviembre";
      mes[12] = "Diciembre";
      mes[13] = "Cierre";
      if (mes[dmes]) {
        return mes[dmes] + " de " + year;
      } else {
        return "Periodo";
      }
    }
  });
  Vue.filter("textempresa", v => {
    let text;
    if (v) {
      if (v.length > 19) {
        text = v.substr(0, 16) + "...";
      } else {
        text = v;
      }
      return text;
    }
  });
  Vue.filter("nletras", (input, currency) => {
    function numeroALetras(num, currency) {
      // Código basado en https://gist.github.com/alfchee/e563340276f89b22042a
      function unidades(num) {
        switch (num) {
          case 1:
            return "UN";
          case 2:
            return "DOS";
          case 3:
            return "TRES";
          case 4:
            return "CUATRO";
          case 5:
            return "CINCO";
          case 6:
            return "SEIS";
          case 7:
            return "SIETE";
          case 8:
            return "OCHO";
          case 9:
            return "NUEVE";
        }

        return "";
      }

      function decenas11(num) {
        var decena = Math.floor(num / 10);
        var unidad = num - decena * 10;

        switch (decena) {
          case 1:
            switch (unidad) {
              case 0:
                return "DIEZ";
              case 1:
                return "ONCE";
              case 2:
                return "DOCE";
              case 3:
                return "TRECE";
              case 4:
                return "CATORCE";
              case 5:
                return "QUINCE";
              default:
                return "DIECI" + unidades(unidad);
            }
          // break;

          case 2:
            switch (unidad) {
              case 0:
                return "VEINTE";
              default:
                return "VEINTI" + unidades(unidad);
            }
          // break;

          case 3:
            return decenasY("TREINTA", unidad);
          case 4:
            return decenasY("CUARENTA", unidad);
          case 5:
            return decenasY("CINCUENTA", unidad);
          case 6:
            return decenasY("SESENTA", unidad);
          case 7:
            return decenasY("SETENTA", unidad);
          case 8:
            return decenasY("OCHENTA", unidad);
          case 9:
            return decenasY("NOVENTA", unidad);
          case 0:
            return unidades(unidad);
        }
      }

      function decenasY(strSin, numUnidades) {
        if (numUnidades > 0) return strSin + " Y " + unidades(numUnidades);

        return strSin;
      } // decenasY()

      function centenas(num) {
        var centenas1 = Math.floor(num / 100);
        var decenas = num - centenas1 * 100;

        switch (centenas1) {
          case 1:
            if (decenas > 0) return "CIENTO " + decenas11(decenas);
            return "CIEN";
          case 2:
            return "DOSCIENTOS " + decenas11(decenas);
          case 3:
            return "TRESCIENTOS " + decenas11(decenas);
          case 4:
            return "CUATROCIENTOS " + decenas11(decenas);
          case 5:
            return "QUINIENTOS " + decenas11(decenas);
          case 6:
            return "SEISCIENTOS " + decenas11(decenas);
          case 7:
            return "SETECIENTOS " + decenas11(decenas);
          case 8:
            return "OCHOCIENTOS " + decenas11(decenas);
          case 9:
            return "NOVECIENTOS " + decenas11(decenas);
        }

        return decenas11(decenas);
      } // centenas()

      function seccion(num, divisor, strSingular, strPlural) {
        var cientos = Math.floor(num / divisor);
        var resto = num - cientos * divisor;

        var varras = "";

        if (cientos > 0)
          if (cientos > 1) varras = centenas(cientos) + " " + strPlural;
          else varras = strSingular;

        if (resto > 0) varras += "";

        return varras;
      } // seccion()

      function miles(num) {
        var divisor = 1000;
        var cientos = Math.floor(num / divisor);
        var resto = num - cientos * divisor;

        var strMiles = seccion(num, divisor, "UN MIL", "MIL");
        var strCentenas = centenas(resto);

        if (strMiles === "") return strCentenas;

        return strMiles + " " + strCentenas;
      } // miles()

      function millones(num) {
        var divisor = 1000000;
        var cientos = Math.floor(num / divisor);
        var resto = num - cientos * divisor;

        var strMillones = seccion(num, divisor, "UN MILLON", "MILLONES");
        var strMiles = miles(resto);

        if (strMillones === "") return strMiles;

        return strMillones + " " + strMiles;
      } // millones()

      function numeroAvarras(num, currency) {
        currency = currency || {};
        var data = {
          numero: num,
          enteros: Math.floor(num),
          centavos: Math.round(num * 100) - Math.floor(num) * 100,
          varrasCentavos: "",
          varrasMonedaPlural: currency.plural || "PESOS", // 'PESOS', 'Dólares', 'Bolívares', 'etcs'
          varrasMonedaSingular: currency.singular || "PESO", // 'PESO', 'Dólar', 'Bolivar', 'etc'
          varrasMonedaCentavoPlural: currency.centPlural || "CENTAV",
          varrasMonedaCentavoSingular:
            currency.centSingular || "CHIQUI PESO CHILENO"
        };

        if (data.centavos > 0) {
          var centavos = "";
          if (data.centavos === 1)
            centavos =
              millones(data.centavos) + " " + data.varrasMonedaCentavoSingular;
          else
            centavos =
              millones(data.centavos) + " " + data.varrasMonedaCentavoPlural;
          data.varrasCentavos = "CON " + centavos;
        }

        if (data.enteros === 0)
          return "CERO " + data.varrasMonedaPlural + " " + data.varrasCentavos;
        if (data.enteros === 1)
          return (
            millones(data.enteros) +
            " " +
            data.varrasMonedaSingular +
            " " +
            data.varrasCentavos
          );
        else
          return (
            millones(data.enteros) +
            " " +
            data.varrasMonedaPlural +
            " " +
            data.varrasCentavos
          );
      }
      var dato = numeroAvarras(num, currency);
      return dato;
    }
    return numeroALetras(input, {
      plural: "PESOS",
      singular: "PESO",
      centPlural: "CENTAVOS",
      centSingular: "CENTAVO"
    });
  });
  Vue.filter("dverif", input => {
    if (input) {
      var arreglo, x, y, z, i, nit1, dv1;
      nit1 = input.toString();
      if (isNaN(nit1)) {
        return "";
      } else {
        arreglo = new Array(16);
        x = 0;
        y = 0;
        z = nit1.length;
        arreglo[1] = 3;
        arreglo[2] = 7;
        arreglo[3] = 13;
        arreglo[4] = 17;
        arreglo[5] = 19;
        arreglo[6] = 23;
        arreglo[7] = 29;
        arreglo[8] = 37;
        arreglo[9] = 41;
        arreglo[10] = 43;
        arreglo[11] = 47;
        arreglo[12] = 53;
        arreglo[13] = 59;
        arreglo[14] = 67;
        arreglo[15] = 71;
        for (i = 0; i < z; i++) {
          y = nit1.substr(i, 1);
          x += y * arreglo[z - i];
        }
        y = x % 11;
        if (y > 1) {
          dv1 = 11 - y;
        } else {
          dv1 = y;
        }
        dv1 = "-" + dv1;
        return dv1;
      }
    }
  });
};

export default millions;



// WEBPACK FOOTER //
// ./src/filters/numbers.js